<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="taxis"
      :pagination.sync="pagination"
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td>{{props.item.registration_number}}</td>
          <td>{{props.item.plate_number}}</td>
          <td>{{ rideTypeForTaxi(props.item.ride_type_id) }}</td>
          <td>{{props.item.num_seats}}</td>
          <td>{{props.item.hackney_carriage ? "Yes" : "No"}}</td>
          <td>
            <AttributesForTaxiCell :taxi="props.item"></AttributesForTaxiCell>
          </td>
          <td>{{props.item.make}}</td>
          <td>{{props.item.model}}</td>
          <td>{{props.item.colour}}</td>
          <td>{{props.item.council}}</td>
          <td>
            <ul>
              <li v-for="driver in props.item.drivers">
                <a :href="'/driver/view/' + driver.id">
                  <b>{{ driver.callsign }}</b>
                </a>
                {{driver.name}}
              </li>
            </ul>
          </td>
          <td>
            <v-btn class="text-none" small v-on:click.stop="goToDriver(props.item.id)">View</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { replaceStart } from "@/components/util/PhoneNumbers.js";

import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";

export default {
  name: "taxi_list",
  components: {
    AttributesForTaxiCell
  },
  props: {
    taxis: Array,
    rideTypes: Array,
    paginationProp: Object
  },
  mounted: function() {
    console.log("Replace Start:" + replaceStart);
  },
  data: function() {
    return {
      pagination: this.paginationProp,
      headers: [
        {
          text: "REG",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Plate Number",
          align: "left",
          sortable: false,
          value: "contact_number"
        },
        {
          text: "Ride Type",
          align: "left",
          sortable: false,
          value: "ride_type"
        },
        {
          text: "Number of Seats",
          align: "left",
          sortable: false,
          value: "taxi"
        },
        {
          text: "Hackney Carriage",
          align: "left",
          sortable: false,
          value: "hackney"
        },
        {
          text: "Attributes",
          align: "left",
          sortable: false,
          value: "attributes"
        },
        {
          text: "Make",
          align: "left",
          sortable: false,
          value: "make"
        },
        {
          text: "Model",
          align: "left",
          sortable: false,
          value: "model"
        },
        {
          text: "Colour",
          align: "left",
          sortable: false,
          value: "color"
        },
        {
          text: "Council",
          align: "left",
          sortable: false,
          value: "council"
        },
        {
          text: "Drivers",
          align: "left",
          sortable: false,
          value: "hackney"
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "hackney"
        }
      ]
    };
  },
  methods: {
    rideTypeForTaxi: function(id) {
      if (id == null) {
        return "-";
      }

      var rideType = this.rideTypes.find(function(rt) {
        return rt.id == id;
      });

      if (rideType == null) {
        return "-";
      }

      return rideType.name;
    },
    goToDriver: function(id) {
      this.$router.push(`/taxi/edit/${id}`);
    },
    doNothing: function() {},
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
a {
  color: #42b983;
}

// table.v-table tbody tr td {
//   // height: 19px;
//   padding: 2px 3px !important;
// }

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
